export default "__VITE_ASSET__BlTKNQqM__"